<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <v-row>
          <v-col md="4">Company Name:</v-col>
          <v-col md="8">{{ partner.company_name }}</v-col>
        </v-row>
        <v-row>
          <v-col md="4">Total Users:</v-col>
          <v-col md="8">{{ partner.total_members }}</v-col>
        </v-row>
      </v-col>
      <v-col md="6">
        <v-row>
          <v-col md="4">Administrator:</v-col>
          <v-col md="8">{{ partner.first_name }} {{partner.last_name}}</v-col>
        </v-row>
        <v-row>
          <v-col md="4">Email:</v-col>
          <v-col md="8">{{ partner.email }}</v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LayoutBasic from "@/layouts/PartnerHub";
import partnerAPI from "@/api/partner.js";

export default {
  name: "PartnerDetails",
  components: {
    LayoutBasic
  },
  data() {
    return {
      partner: [],
      partnerInfo: [],
      partnerUsers: [],
      loading: false,
      partnerId: this.$route.params.id,
      params: "",
      searchParams: ""
    };
  },
  mounted() {
    this.getPartnerData();
  },
  computed: {},
  watch: {},
  methods: {
    getPartnerData() {
      this.loading = true;
      partnerAPI.getPartnerByID(this.partnerId).then(resp => {
        this.partner = resp.data.data;
        this.loading = false;
      });
    }
  }
};
</script>